// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## PlanInterval Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.PlanInterval.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## PlanInterval Create
/**
 *
 * @param {{"startDayOfWeek": string,"endDayOfWeek": string,"startTimeSpan": number,"endTimeSpan": number,"planDays": number}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.PlanInterval.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PlanInterval Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.PlanInterval.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PlanInterval Update
/**
 *
 * @param {{"startDate": string,"endDate": string,"expiredDay": number, isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.PlanInterval.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PlanInterval Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.PlanInterval.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
